"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserReferWorkerComponentParameters = void 0;
exports.UserReferWorkerComponentParameters = [
    {
        id: 'refer',
        label: 'Refer Label',
        description: 'Input Param - The label for referring a worker',
        type: 'string',
        required: false,
        paramType: 'STRING',
    },
    {
        id: 'deny',
        label: 'Deny Label',
        description: 'Input Param - The label for denying a referral',
        type: 'string',
        required: false,
        paramType: 'STRING',
    },
    {
        id: 'referred',
        label: 'Referred Output',
        description: 'Output Param - The boolean value indicating whether the worker has referred another worker',
        type: 'output',
        paramType: 'BOOLEAN',
        required: true,
    },
];
//# sourceMappingURL=UserReferWorkerComponent.js.map